import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UUA_API_URL } from '../../app.constants';

@Injectable()
export class PasswordService {

    constructor(private http: HttpClient) {}

    save(newPassword: string): Observable<any> {
        return this.http.post(UUA_API_URL + '/v1/account/change-password', newPassword);
    }
}
